import { useEffect, useState } from 'react'

const MOBILE_USER_AGENT_REGEX = /Android|iPhone|iPad|iPod|Mobile/i

const getIsMobileDevice = () =>
    typeof window !== 'undefined' &&
    (MOBILE_USER_AGENT_REGEX.test(window.navigator.userAgent || '') ||
        ('matchMedia' in window && window.matchMedia('(pointer: coarse)').matches))

export default function useIsMobileDevice() {
    const [isMobileDevice, setIsMobileDevice] = useState(getIsMobileDevice)

    useEffect(() => {
        if (!('matchMedia' in window)) return

        const mediaQuery = window.matchMedia('(pointer: coarse)')
        const handleChange = () => setIsMobileDevice(getIsMobileDevice())

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])

    return isMobileDevice
}
